var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLightCheckmark = function SvgLightCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_635_12087)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83073 15.2337L6.33073 11.7511L5.16406 12.912L9.83073 17.5554L19.8307 7.6052L18.6641 6.44434L9.83073 15.2337Z",
    fill: "#0F0F0F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_635_12087",
    x1: -1.34546,
    y1: -2.44286,
    x2: 9.54651,
    y2: 30.2212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543855,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0B0B0"
  })))));
};
export { SvgLightCheckmark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl82MzVfMTIwODcpIi8+CjxwYXRoIGQ9Ik05LjgzMDczIDE1LjIzMzdMNi4zMzA3MyAxMS43NTExTDUuMTY0MDYgMTIuOTEyTDkuODMwNzMgMTcuNTU1NEwxOS44MzA3IDcuNjA1MkwxOC42NjQxIDYuNDQ0MzRMOS44MzA3MyAxNS4yMzM3WiIgZmlsbD0iIzBGMEYwRiIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzYzNV8xMjA4NyIgeDE9Ii0xLjM0NTQ2IiB5MT0iLTIuNDQyODYiIHgyPSI5LjU0NjUxIiB5Mj0iMzAuMjIxMiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjQjBCMEIwIi8+CjxzdG9wIG9mZnNldD0iMC4zNCIgc3RvcC1jb2xvcj0iI0U3RTdFNyIvPgo8c3RvcCBvZmZzZXQ9IjAuNTQzODU1IiBzdG9wLWNvbG9yPSJ3aGl0ZSIvPgo8c3RvcCBvZmZzZXQ9IjAuNzUiIHN0b3AtY29sb3I9IiNFN0U3RTciLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjQjBCMEIwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";